
<template>
  <div class="container-fluid loginPages p-0">
    <div class="container py-3 py-md-4 px-0">
      <div class="row m-0">
        <img src="static/images/logo.png" class="img-fluid" />
      </div>
    </div>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1, shrink-to-fit=no"
    />
    <div class="container mt-3 mb-5 px-0">
      <div class="row loginInfo">
        <div class="col-12 col-md-6">
          <h2 class="title">{{ $ml.get("JOIN_MAXIMUM_CRM") }}</h2>
          <div class="desc">
            {{ $ml.get("ALL_FEATURES_IN_SINGLE_PLAN") }}
            <!-- <br/><span>$ 3,99 / {{$ml.get('MOUNT_PER_USER')}}</span> <span class="small-font">{{$ml.get('PAID_ANNUALY')}}</span> -->
          </div>
          <div class="text dNone">
            {{ $ml.get("COMPREHENSIVE_FEATURES") }} <br />
            {{ $ml.get("USER_FRIENDLY_DESIGN") }}<br />
            {{ $ml.get("FREE_TECH_SUPPORT") }} <br />
            {{ $ml.get("CLOUD_BASED_CRM") }} <br />
            {{ $ml.get("BEST_IN_CLASS_SECURITY") }}
          </div>
          <router-link
            class="saas-btn saas-btn-transparent mt-4 saas-btn"
            to="/signup"
            >{{ $ml.get("REGISTER") }}</router-link
          >
        </div>
        <div class="col-12 col-md-6 mt-4 mt-md-0">
          <h2 class="title">{{ $ml.get("LOGIN") }}</h2>
          <div>
            <form class="login-form saas-form" v-on:submit.prevent="login">
              <label for="email" class="saas-label">{{
                $ml.get("E_MAIL")
              }}</label>
              <div
                class="saas-form-control"
                :class="{ isDanger: emailError.state == true }"
              >
                <input
                  type="text"
                  @input="emailValidation"
                  class="saas-input"
                  v-model="email"
                />
                <div class="col-12 d-block px-0 input-error">
                  <span class="alert-input" v-if="emailError.state">{{
                    emailError.message
                  }}</span>
                </div>
              </div>
              <div
                class="saas-form-control"
                :class="{ isDanger: passwordError.state == true }"
              >
                <label for="password" class="saas-label">{{
                  $ml.get("PASSWORD")
                }}</label>
                <input
                  type="password"
                  @input="passwordValidation"
                  class="saas-input"
                  v-model="password"
                />
                <div class="col-12 d-block px-0 input-error">
                  <span class="alert-input" v-if="passwordError.state">{{
                    passwordError.message
                  }}</span>
                </div>
              </div>
              <div class="form-check">
                <label for="remember"
                  ><input type="checkbox" id="remember" v-model="rememberMe" />
                  {{ $ml.get("REMEMBER_ME") }}</label
                >
                <router-link class="float-right" to="/forgotpassword">{{
                  $ml.get("FARGOT_MY_PASSWORD")
                }}</router-link>
              </div>
              <input
                type="submit"
                class="saas-btn mt-2"
                :value="$ml.get('LOGIN')"
              />
            </form>
          </div>
        </div>
      </div>
    </div>
    <orderPayment v-if="isPaymentModalActive" ref="buymodalSelector"></orderPayment>
    <!-- @loginPrice="$event"  -->
    <!-- <orderPayment ref="buymodalSelector"  ><slot name="buymodal" v-if="buymodal==true"></slot></orderPayment> slot için orderpayment sayfası modala slot="buymodal" tanımla -->
    <notifications
      group="foo"
      style="margin-right: 5%; margin-top: 5%"
      position="top right"
    />
    <!-- @loginPrice="changePrice($event)" olarak yazılırsa method oluştur data da price tanımla-->
    <Footer></Footer>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import Footer from "./footer.vue";
import defineAbilityFor from "../services/rules";
import orderPayment from "../components/orderPayment.vue";

import swal from "sweetalert";
export default {
  name: "Login",
  data() {
    return {
      rememberMe: false,
      email: "",
      password: "",
      emailError: { state: false, message: "" },
      passwordError: { state: false, message: "" },
      isPaymentModalActive: false,
      twofaActivated: false,
      // price:[],
      // buymodal:false
    };
  },
  computed: {
    ...mapState(["baseUrl", "windowWidth", "maxMobilSize", "maxTabletSize"]),
    ...mapGetters(["company_settings"]),
  },
  components: {
    Footer,
    orderPayment,
  },
  methods: {
    // changePrice(price){
    //   this.price=price;
    // },
    rememberMeMethod() {
      this.email = localStorage.getItem("email");
      this.password = localStorage.getItem("password");
    },
    isLogin() {
      axios({
        method: "GET",
        url: "/authenticate",
        baseURL: this.baseUrl,
        withCredentials: true,
      })
        .then((res) => {
          return res;
        })
        .then((res) => {
          if (res.data.status) {
            if (this.windowWidth < this.maxMobilSize) {
              this.$router.push("/opportunities");
            } else {
              this.$router.push("/deals");
            }
          } else {
            //this.$router.push('/login')
          }
        });
    },
    validateEmail(email) {
      const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    emailValidation() {
      this.emailError.state = false;
      this.emailError.message = "";
      if (this.email == "") {
        this.emailError.message = this.$ml.get("PLEASE_ENTER_YOUR_MAIL");
        this.emailError.state = true;
        return false;
      } else if (!this.validateEmail(this.email)) {
        this.emailError.message = this.$ml.get("PLEASE_ENTER_VALID_MAIL");
        this.emailError.state = true;
        return false;
      }
      this.emailError.state = false;
      return true;
    },
    passwordValidation() {
      this.passwordError.message = "";
      this.passwordError.state = false;
      if (this.password == "") {
        this.passwordError.message = this.$ml.get("PLEASE_ENTER_PASSWORD");
        this.passwordError.state = true;
        return false;
      } else {
        this.passwordError.state = false;
        return true;
      }
    },
    login() {
      this.emailValidation();
      this.passwordValidation();
      if (!this.emailValidation() || !this.passwordValidation()) {
        return false;
      }

      // axios({
      //   method:'POST',
      //   url:'/authenticate',
      //   baseURL: this.baseUrl,
      //   data: {
      //       email:this.email,
      //       password:this.password,
      //       rememberMe:this.rememberMe
      //   },
      //   withCredentials:true
      //   }).then((res)=>{
      //       return res
      //   }).then((res)=>{
      //   if(res.data.status.code==0){
      //       this.user=res.data.content.user
      //       localStorage.setItem('name', this.user.name)
      //       localStorage.setItem('surname', this.user.surName)
      //       if(this.rememberMe){
      //         localStorage.setItem('email',this.user.email)
      //         localStorage.setItem('password',this.password)
      //       }
      //       this.setUserName()
      //       localStorage.roleId=this.user.userRoleId
      //       localStorage.cuid = this.user._id.$oid
      //       if(this.user.language){
      //         this.$ml.change(this.user.language)
      //       }
      //       this.$emit("roleId",this.user.userRoleId)
      //       this.getPermissionSetF(this.user.userRoleId)
      //       this.getCompanySettings().then((res)=>{ return res}).then((res)=>{
      //           localStorage.defaultCurrency=this.company_settings.currency
      //       })
      //       if(this.user.activation){
      //         this.isPaymentModalActive=true
      //       }

      //   }else{
      //     if(res.data.status.code==2050){
      //       var details = this.$ml.get('PASSIVE_ACCOUNT')
      //     }
      //     else{
      //       var details = res.data.status.desc
      //     }
      //     this.$notify({
      //       group: 'foo',
      //       type: 'error',
      //       title: this.$ml.get('ERROR'),
      //       text: details
      //     })
      //   }
      // })

      axios({
        method: "POST",
        url: "/authenticateUser_2fa",
        baseURL: this.baseUrl,
        data: {
          email: this.email,
          password: this.password,
          rememberMe: this.rememberMe,
        },
        withCredentials: true,
      })
        .then((res) => {
          return res;
        })
        .then((res) => {
          if (res.data.status.code == 0) {
            this.twofaActivated = res.data.content.twofa_activated;
            localStorage.setItem(
              "twofaActivated",
              JSON.stringify(this.twofaActivated)
            );
              localStorage.setItem('email',this.email)
              localStorage.setItem('password',this.password)
              this.$router.push("/loginTwoFactor");
           
          } else {
            if (res.data.status.code == 2050) {
              var details = this.$ml.get("PASSIVE_ACCOUNT");
            } else {
              var details = res.data.status.desc;
            }
            this.$notify({
              group: "foo",
              type: "error",
              title: this.$ml.get("ERROR"),
              text: details,
            });
          }
        });
    },
    getPermissionSetF(userRoleId) {
      axios({
        method: "POST",
        url: "/getPermissionSet",
        data: {
          roleId: userRoleId,
        },
        baseURL: this.baseUrl,
        withCredentials: true,
      })
        .then((res) => {
          return res;
        })
        .then((res) => {
          if (res.data.status.code == 0) {
            localStorage.loginCookie = true;
            this.setRules();
            if (this.windowWidth < this.maxMobilSize) {
              this.$router.push("/opportunities");
            } else {
              this.$router.push("/deals");
            }
          } else if (res.data.status.code == 2054) {
            // this.$router.push('/orderPayment')
            //  this.$router.push('/settings')
            this.$router.push({
              path: "settings",
              query: { paymentStatus: "userManagement" },
            });
            //  $('#buymodal').modal('show')
            console.log("token yok ****///////////////*****");
            //  this.$refs.buymodalSelector.showBuyModal()
            //  let asd=this.$refs.buymodalSelector.data.price
            //   let dataaa=this.$refs.buymodalSelector.data
            //  console.log(dataaa);
            //  console.log("asd başlangıç");
            //   console.log(asd)
            //   console.log("asd bitiş");
            //  this.$refs.buymodalSelector.getPrice()
            //    this.$refs.buymodalSelector.getSavedCreditCards()
            //  this.buymodal=true
          }
        });
    },
    setRules() {
      try {
        axios({
          method: "GET",
          url: `/getUserPermissions`,
          baseURL: process.env.API_URL,
          withCredentials: true,
        }).then((rez) => {
          var permissions = [];
          console.log("res of get user permissions");
          console.log(rez);
          permissions = rez.data;
          localStorage.setItem("rules", JSON.stringify(permissions));
          this.$ability.update(defineAbilityFor(permissions));
        });
      } catch (err) {
        // Handle Error Here
        console.error(err);
      }
    },
    ...mapActions(["updateLoading", "getCompanySettings", "setUserName"]),
  },
  created() {
    this.$root.$refs.Login = this;
    this.isLogin();
    this.rememberMeMethod();
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700,900");
body {
  background-color: #e5e5e5 !important;
  color: #677294;
}
.loginPage {
  font: 400 14px/28px "Poppins", sans-serif !important;
  padding-bottom: 150px !important;
}
.form-check {
  padding-left: 0rem;
  color: #677294;
}
.form-check a {
  color: #677294;
}
.form-check a:hover {
  text-decoration: none;
  color: #1991eb;
}
.form-check label {
  cursor: pointer;
}
h1 {
  color: white;
}
.form-check {
  font-size: 0.9rem;
}
@media (max-width: 576px) {
  .dNone {
    display: none;
  }
}
</style>
